import { render, staticRenderFns } from "./newwalfare.vue?vue&type=template&id=97f9950a&scoped=true&"
import script from "./newwalfare.vue?vue&type=script&lang=js&"
export * from "./newwalfare.vue?vue&type=script&lang=js&"
import style0 from "./newwalfare.vue?vue&type=style&index=0&id=97f9950a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f9950a",
  null
  
)

export default component.exports